import { render } from "./LocaleSelector.vue?vue&type=template&id=3af94a4c&scoped=true"
import script from "./LocaleSelector.vue?vue&type=script&lang=js"
export * from "./LocaleSelector.vue?vue&type=script&lang=js"

import "./LocaleSelector.vue?vue&type=style&index=0&id=3af94a4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af94a4c"]])

export default __exports__